<template>
  <Transition name="fade">
    <div
      v-if="visible"
      class="position-fixed bottom-0 start-0 end-0 d-flex flex-column align-items-center"
      style="z-index: 1040; pointer-events: none;"
    >
      <!-- Chevrons clickables -->
      <div
        class="position-relative d-flex flex-column align-items-center pb-2 px-4"
        style="pointer-events: all; cursor: pointer; gap: 0;"
        role="button"
        aria-label="Faire défiler vers le bas"
        @click="scrollDown"
      >
        <svg class="chevron chevron-1" viewBox="0 0 24 12" xmlns="http://www.w3.org/2000/svg" style="margin-bottom: -4px;">
          <polyline points="2,2 12,10 22,2" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        <svg class="chevron chevron-2" viewBox="0 0 24 12" xmlns="http://www.w3.org/2000/svg">
          <polyline points="2,2 12,10 22,2" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </div>
    </div>
  </Transition>
</template>

<script setup lang="ts">
import { ref, onMounted, onUnmounted } from 'vue'

const THRESHOLD = 90
const visible = ref(false)

defineExpose({ checkScrollability })

function checkScrollability() {
  visible.value = document.documentElement.scrollHeight - (window.scrollY + window.innerHeight) > THRESHOLD
}

function scrollDown() {
  window.scrollBy({ top: window.innerHeight * 0.8, behavior: 'smooth' })
}

onMounted(() => {
  setTimeout(() => {
    checkScrollability()
  }, 500)
  window.addEventListener('scroll', checkScrollability, { passive: true })
  window.addEventListener('resize', checkScrollability, { passive: true })
})

onUnmounted(() => {
  window.removeEventListener('scroll', checkScrollability)
  window.removeEventListener('resize', checkScrollability)
})
</script>

<style scoped>
.chevron {
  width: 28px;
  height: 14px;
  color: rgba(255, 255, 255, 0.9);
  display: block;
  filter: drop-shadow(0 0 1px rgba(0,0,0,0.9)) drop-shadow(0 1px 4px rgba(0,0,0,0.7));
}

.chevron-1 {
  animation: chevron-bounce 1.6s ease-in-out infinite;
  opacity: 0.6;
}

.chevron-2 {
  animation: chevron-bounce 1.6s ease-in-out infinite 0.2s;
  opacity: 0.9;
}

@keyframes chevron-bounce {
  0%, 100% { transform: translateY(0); }
  50% { transform: translateY(4px); }
}
</style>
